import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const MyPage: React.FC = () => {
  const [userData, setUserData] = useState<any>(null);

  useEffect(() => {
    // 사용자 데이터를 가져오는 예시 (API 호출)
    // 여기서는 더미 데이터로 예시를 진행합니다.
    const fetchedUserData = {
      name: '홍길동',
      email: 'hong@example.com',
      resumeCompleted: false, // 이력서 제출 여부
    };
    setUserData(fetchedUserData);
  }, []);

  if (!userData) {
    return <div>로딩 중...</div>; // 데이터를 로딩 중이라면
  }

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg">
      <h1 className="text-3xl font-semibold text-center mb-6">마이페이지</h1>

      <div className="mb-6">
        <h3 className="text-xl font-semibold text-gray-700 mb-4">사용자 정보</h3>
        <div className="text-gray-600">
          <p><strong>이름:</strong> {userData.name}</p>
          <p><strong>이메일:</strong> {userData.email}</p>
        </div>
      </div>

      {/* 이력서 상태 */}
      <div className="mb-6">
        <h3 className="text-xl font-semibold text-gray-700 mb-4">이력서</h3>
        <div className="text-gray-600">
          {userData.resumeCompleted ? (
            <p>이력서가 제출되었습니다.</p>
          ) : (
            <div>
              <p>이력서를 제출하지 않았습니다.</p>
              <Link to="/resume" className="text-indigo-600 hover:text-indigo-800">이력서 작성하기</Link>
            </div>
          )}
        </div>
      </div>

      {/* 개인정보 수정 */}
      <div className="mb-6">
        <h3 className="text-xl font-semibold text-gray-700 mb-4">개인정보 수정</h3>
        <Link to="/profile/edit" className="text-indigo-600 hover:text-indigo-800">개인정보 수정하기</Link>
      </div>

      {/* 기타 항목, 로그아웃 등 */}
      <div className="mt-6">
        <Link to="/login" className="text-red-600 hover:text-red-800">로그아웃</Link>
      </div>
    </div>
  );
};

export default MyPage;
